import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import DeptPrintDetailEdit from './DeptPrintDetailEdit';
import { SocketContext } from '../../../App';
import { useContext, useEffect, useRef } from 'react';

export default function DeptPrintDetail(props: any) {

    const ref = useRef<any>(undefined);

    /** api服务id */
    const apiId = 'deptPrintDetail';

    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // handleChangeOne = ref.current.handleChangeOne;
        }

        //同步获取数据 async - await
        const fetchData = async () => {
        }

        if (contextData?.currentBranchStoreId) {
            if (contextData?.refresh) {
                onRefresh({ branchStoreId: contextData?.currentBranchStoreId })
            }
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentBranchStoreId]); //初始化数据

    const onRefresh = (item: any) => {
        const { branchStoreId } = item;
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                branchStoreId
            }
        }
        ref.current.initData(currentData);

        setContextData({ ...contextData, refresh: false })
    }

    //表头
    const columnsHead = [
        // {
        //     title: '门店',
        //     dataIndex: 'branchStoreName',
        //     render: (text: any, record: any) => {
        //         return (
        //             <div>{record.shopCategory.branchStore.brand.brandName + " " + record.shopCategory.branchStore.branchStoreName}</div>
        //         )
        //     }
        // },
        {
            title: '部门',
            dataIndex: 'deptName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.dept.deptName}</div>
                )
            }
        },
        {
            title: '打印内容',
            dataIndex: 'detailName',
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '部门打印内容',
        apiId: 'deptPrintDetail',
        showStates: true,
        columns,
        pagination: true,
        EditComponent: DeptPrintDetailEdit,
        // sendPageData: { branchStoreId: localStorage.getItem("currentBranchStoreId") },
        sendPageData: { branchStoreId: contextData?.currentBranchStoreId },
        mountDataOptions: {
            userMount: {
                isDept: true
            }
        }
    };

    return (
        <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>
    )
}